import React, { Fragment } from 'react';

import useMeetReconUpload from './UseMeetReconUpload';

import PrimaryButton from '../../buttons/PrimaryButton';
import SecondaryButton from '../../buttons/SecondaryButton';
import PopUpModal from '../../dialogs/PopUpModal';
import Constants from '../../../utils/Constants';
import ActionIntraPageButton from '../../buttons/ActionIntraPageButton';
import ViewReport from '../../embeddedReports/ViewReport';

import global from '../../../components/GlobalStyle.module.css';

const MeetReconUpload = ({ meetId }) => {
  const FileUpload = () => {
    const hiddenFileInput = React.useRef(null);
    let fileReader;

    const handleSelectFileClicked = (e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      hiddenFileInput.current.click();
    };

    const handleFileRead = (event) => {
      const fileContent = fileReader.result;
      processFile(fileContent);
    };

    const handleFileChosen = (file) => {
      fileReader = new FileReader();
      fileReader.onloadend = handleFileRead;
      fileReader.readAsText(file);
    };

    return (
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton onClick={handleSelectFileClicked}>Select a File</PrimaryButton>&nbsp;
          Hy-Tek (*.cl2), SDIF (*.sd3), Lenex (*.lef)
        </div>
        <input
          type='file'
          id='file'
          ref={hiddenFileInput}
          style={{ display: 'none' }}
          onChange={e => handleFileChosen(e.target.files[0])} />
      </div>
    );
  };

  const {
    INITIAL_VIEW_STATE,
    viewState,
    setViewState,
    meetReconState,
    jsonFileState,
    processFile,
    onDownloadClicked,
    onSubmitMeetReconResults,
    onRunMeetReconReport
  } = useMeetReconUpload(meetId);

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <FileUpload />
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin" style={{ display: jsonFileState.reconContent.length === 0 ? 'none' : 'flex' }}>
        <div className="col-xs-12">
          <p className={global.Bold}>Number of Clubs: {jsonFileState.clubCount}</p>
          <p className={global.Bold}>Number of Swimmers: {jsonFileState.swimmerCount}</p>
          <p className={global.Bold}>Number of File Errors: {jsonFileState.errors || 0} {jsonFileState.errors > 0 ? " - download JSON files to view error details" : ""}</p>
        </div>
      </div>
      {meetReconState.isSaved
        ? <Fragment>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              <p className={global.Bold}>Meet Recon data was uploaded. Please use the 'Run Meet Recon Report' button to view the uploaded data.</p>
            </div>
          </div>
        </Fragment>
        : <Fragment />}
      {meetReconState.message.length > 0 && meetReconState.message !== Constants.SAVING_MSG
        ? <Fragment>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              <p className={global.Bold}>Meet Recon Save Error: {meetReconState.message}</p>
            </div>
          </div>
        </Fragment>
        : <Fragment />}
      <div className="row usas-extra-top-margin usas-extra-bottom-margin"
        style={{ display: jsonFileState.reconContent.length === 0 ? 'none' : 'flex' }}>
        <div className="col-xs-12 usas-extra-top-margin">
          <SecondaryButton type="button" onClick={onDownloadClicked}>Download JSON Files</SecondaryButton> &nbsp;
          <PrimaryButton type="button" onClick={onSubmitMeetReconResults}>Upload Meet Recon Info</PrimaryButton> &nbsp;
          {meetReconState?.isSaved === true &&
            <ActionIntraPageButton type="button" onClick={() => onRunMeetReconReport(meetId)}>Run Meet Recon Report</ActionIntraPageButton>}
        </div>
      </div>
      {jsonFileState.errorsArray.length > 0 &&
        <>
          <div className="row">
            <div className="col-xs-12">
              <p className={global.Bold} style={{ fontSize: '20px' }}>Errors Found:</p>
              <p style={{ color: '	#636363', fontSize: '18px' }}>
                The following errors were found and have been skipped. The line number is where the error occured in the uploaded file. You can continue to upload Meet Recon results without fixing these errors.
              </p>
            </div>
          </div>
          <div className="row" style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {jsonFileState.errorsArray.map((error, index) => (
              <div key={index} className="col-xs-12">
                <p style={{ color: 'red', lineHeight: '1', margin: '2px 0' }}>{error.errorMessage}  --  Line Number: {error.lineNumber}</p>
              </div>
            ))}
          </div>
        </>
      }
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={"Processing"}
        displayPopUp={jsonFileState.reconContent.length === 0 && jsonFileState.processingStarted === true}
      />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.UPLOADING_MSG}
        displayPopUp={meetReconState?.isSaving} />
      {viewState.showReport === true &&
        <ViewReport reportInfoId={viewState.reportInfoId} reportParameters={viewState.reportParameters} onBackToGrid={() => setViewState({ INITIAL_VIEW_STATE })} />}
    </Fragment>
  );
};

export default MeetReconUpload;